<style scoped>
.calendar {
  margin: auto;
  width: 100%;
  min-width: 300px;
  background: #fff;
  /*font-family: "PingFang SC","Hiragino Sans GB","STHeiti","Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;*/
  user-select: none;
}
.calendar table {
  clear: both;
  width: 100%;
  border-collapse: collapse;
}
.calendar table.weeks {
  background: #f2f2f2;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 69px;
}
.calendar table.weeks td {
  height: 35px;
}
.calendar table.weeks td.red {
  color: #e6212f;
}
.calendar td.week {
  color: #333;
  font-size: 13px;
  pointer-events: none !important;
  cursor: default !important;
}
.dateList {
  margin-top: 105px;
}
.calendar td {
  margin: 2px !important;
  padding: 0px 0;
  width: 14.28571429%;
  height: 66px;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  line-height: 125%;
  cursor: pointer;
  position: relative;
  vertical-align: top;
}
.calendar td.selected {
  background: #e6212f;
  color: #fff;
}
.calendar td.disabled {
  color: #ccc;
  pointer-events: none !important;
  cursor: default !important;
}
.calendar td.disabled div {
  color: #ccc;
}
.calendar td span {
  display: block;
  max-width: 40px;
  height: 26px;
  font-size: 17px;
  line-height: 26px;
  margin: 0px auto;
  border-radius: 20px;
  margin-top: 20px;
  font-weight: 700;
}
.calendar td:not(.disabled) span.red,
.calendar td:not(.disabled) span.red + div {
  color: #e6212f;
}
.calendar td .text {
  position: absolute;
  top: 44px;
  left: 0;
  right: 0;
  text-align: center;
  padding: 2px;
  font-size: 11px;
  line-height: 1.2;
  color: #999;
}
.calendar td.selected .text {
  color: #fff;
}
.calendar td .text.lunar {
  top: 0px;
}
.calendar td .isGregorianFestival,
.calendar td .isLunarFestival {
  color: #e6212f;
}
.calendar td.selected span.red,
.calendar td.selected span.red + div {
  color: #fff;
}
.calendar td .text.fillUp {
  color: #999;
  font-size: 11px;
  display: none;
}
.backred {
  background: #e6212f;
}
.calendar thead td {
  text-transform: uppercase;
  height: 30px;
  vertical-align: middle;
}
.currentyDate {
  text-align: center;
  width: 100%;
  height: 46px;
  line-height: 46px;
  margin: 0;
  color: #333;
  font-size: 13px;
}
.van-nav-bar {
  background: #fff;
  padding-top: 24px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.van-nav-bar__title {
  font-size: 18px;
  color: #333;
}
.van-icon-arrow-left:before {
  display: none;
}
.van-nav-bar__left {
  left: 11px;
}
.van-icon {
  width: 17px;
  height: 15px;
  display: inline-block;
  background: url(../../../assets/plane/reBack.png) no-repeat center center;
  background-size: 100% 100%;
}
.isiOSX .van-nav-bar {
  padding-top: 44px;
}
.isiOSX table.weeks {
  margin-top: 89px;
}
.isiOSX .dateList {
  margin-top: 125px;
}
</style>

<template>
  <div class="calendar" :class="{ isiOSX: isiOSX }">
    <van-nav-bar title="选择日期" left-arrow @click-left="reBack" />
    <table cellpadding="5" class="weeks">
      <thead>
        <tr>
          <td
            v-for="(week, n) in weeks"
            :key="n"
            class="week"
            :class="{ red: n == 0 || n == 6 }"
          >
            {{ week }}
          </td>
        </tr>
      </thead>
    </table>
    <div class="dateList">
      <div v-for="(alldays, k0) in threeMonth" :key="k0">
        <p class="currentyDate">{{ threeMonth[k0].date }}</p>
        <table cellpadding="5">
          <tbody>
            <tr
              v-for="(day, k1) in alldays.days"
              :key="k1"
              style="{'animation-delay',(k1*30)+'ms'}"
            >
              <td
                v-for="(child, k2) in day"
                :key="k1 - k2"
                :class="{ selected: child.selected, disabled: child.disabled }"
                @click="select(k0, k1, k2, $event)"
              >
                <span
                  :class="{
                    red:
                      k2 == 0 ||
                      k2 == 6 ||
                      (child.isVacation && lunar && !child.isFillUp) ||
                      child.today,
                  }"
                  >{{ child.text || child.day }}</span
                >
                <span class="text lunar fillUp" v-if="child.lunar == '班'">{{
                  child.lunar
                }}</span>
                <div
                  class="text lunar"
                  :class="{
                    isLunarFestival: child.isLunarFestival,
                    isGregorianFestival: child.isGregorianFestival,
                  }"
                  v-if="
                    child.isLunarFestival ||
                    child.isGregorianFestival ||
                    child.isVacation
                  "
                >
                  {{ child.lunar }}
                </div>
                <div class="text" v-if="child.eventName != undefined">
                  {{ child.eventName }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import calendar from "./calendar.js";
export default {
  props: {
    // 多选模式
    multi: {
      type: Boolean,
      default: false,
    },
    // 范围模式
    range: {
      type: Boolean,
      default: false,
    },
    // 默认日期
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 开始选择日期
    //  begin: {
    //    type: Array,
    //    default: function() {
    //      return [];
    //    }
    //  },
    // 结束选择日期
    end: {
      type: Array,
      default: function () {
        return [];
      },
    },

    // 是否小于10补零
    zero: {
      type: Boolean,
      default: false,
    },
    // 屏蔽的日期
    disabled: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 是否显示农历
    lunar: {
      type: Boolean,
      default: false,
    },

    // 自定义星期名称
    weeks: {
      type: Array,
      default: function () {
        return window.navigator.language.toLowerCase() == "zh-cn"
          ? ["日", "一", "二", "三", "四", "五", "六"]
          : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      },
    },
    // 自定义月份
    months: {
      type: Array,
      default: function () {
        return window.navigator.language.toLowerCase() == "zh-cn"
          ? [
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
              "九月",
              "十月",
              "十一月",
              "十二月",
            ]
          : [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ];
      },
    },
    // 自定义事件
    events: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      getValue: "",
      years: [],
      yearsShow: false,
      date: 0,
      year: 0,
      month: 0,
      day: 0,
      days: [],
      flag: 3,
      threeMonth: [],
      multiDays: [],
      today: [],
      begin: [],
      router: "/plane/index",
      festival: {
        //因节日的设置仅包括月份和日期，所以vacationDate字段需要及时维护   ！！！！！！！！！！！！！！！！！！！！
        //2022年所有节假日已包含在内，最迟2022年10月31号需更新2023年1月份信息（2021-12-13）
        vacationDate: {
          //所有放假的日子（阴历节日或阳历节日，仅文字和日期显示红色）和因放假补班的日子（仅控制文字显示灰色#999）全部用阳历的日期设置
          "1-1": "元旦",
          "1-2": "休",
          "1-3": "休",
          "1-29": "班",
          "1-30": "班",
          "1-31": "除夕",
          "2-1": "春节",
          "2-2": "休",
          "2-3": "休",
          "2-4": "休",
          "2-5": "休",
          "2-6": "休",
          "4-2": "班",
          "4-3": "休",
          "4-4": "休",
          "4-5": "清明节",
          "4-24": "班",
          "4-30": "休",
          "5-1": "劳动节",
          "5-2": "休",
          "5-3": "休",
          "5-4": "休",
          "5-7": "班",
          "6-3": "端午节",
          "6-4": "休",
          "6-5": "休",
          "9-10": "中秋节",
          "9-11": "休",
          "9-12": "休",
          "10-1": "国庆节",
          "10-2": "休",
          "10-3": "休",
          "10-4": "休",
          "10-5": "休",
          "10-6": "休",
          "10-7": "休",
          "10-8": "班",
          "10-9": "班",
        },
        lunar: {
          //阴历非放假节日，仅文字显示红色
          "1-15": "元宵节",
          "2-2": "龙头节",
          "7-7": "七夕节",
          "7-15": "中元节",
          "9-9": "重阳节",
          "10-1": "寒衣节",
          "10-15": "下元节",
          "12-8": "腊八节",
          // "12-23": "祭灶节",
          "12-23": "北方小年",
          "12-24": "南方小年",
        },
        gregorian: {
          //阳历非放假节日，仅文字显示红色
          "2-14": "情人节",
          "3-8": "妇女节",
          "3-12": "植树节",
          "4-5": "清明节",
          "5-4": "青年节",
          "6-1": "儿童节",
          "7-1": "建党节",
          "8-1": "建军节",
          "9-10": "教师节",
          "12-24": "平安夜",
          "12-25": "圣诞节",
        },
      },
      rangeBegin: [],
      rangeEnd: [],
      isiOSX: false,
      seleced: { k0: 0, k1: 1, k2: 0 },
    };
  },
  watch: {
    events() {
      this.init();
    },
    value() {
      this.init();
    },
  },
  mounted() {
    this.isiOSX = this.isIphoneX();
    this.init();
    if (this.$route.query.from == 2) {
      this.router = "/select/list";
    } else {
      this.router = "/plane/index";
    }
    var arr = this.$route.query.departure_date.split("-");
    var y_m = arr[0] + "年" + this.checkNum(arr[1]) + "月";
    //  this.seleced = {k0:0,k1:1,k2:0};
    for (let i in this.threeMonth) {
      if (this.threeMonth[i].date == y_m) {
        this.seleced.k0 = i;
        var days = this.threeMonth[i].days;
        for (let j in days) {
          for (let m in days[j]) {
            if (days[j][m].day == this.checkNum(arr[2])) {
              this.seleced.k1 = j;
              this.seleced.k2 = m;
            }
          }
        }
      }
    }

    this.select(this.seleced.k0, this.seleced.k1, this.seleced.k2, null, true);
  },
  methods: {
    checkNum(i) {
      if (i.substr(0, 1) == 0) {
        return i.substr(1, 1);
      } else {
        return i;
      }
    },
    init() {
      let now = new Date();
      this.year = now.getFullYear();
      this.month = now.getMonth();
      this.day = now.getDate();
      this.begin = [this.year, this.month + 1, this.day];
      if (this.value.length > 0) {
        if (this.range) {
          //范围
          this.year = parseInt(this.value[0][0]);
          this.month = parseInt(this.value[0][1]) - 1;
          this.day = parseInt(this.value[0][2]);

          let year2 = parseInt(this.value[1][0]);
          let month2 = parseInt(this.value[1][1]) - 1;
          let day2 = parseInt(this.value[1][2]);

          this.rangeBegin = [this.year, this.month, this.day];
          this.rangeEnd = [year2, month2, day2];
        } else if (this.multi) {
          //多选
          this.multiDays = this.value;
          this.year = parseInt(this.value[0][0]);
          this.month = parseInt(this.value[0][1]) - 1;
          this.day = parseInt(this.value[0][2]);
        } else {
          //单选
          this.year = parseInt(this.value[0]);
          this.month = parseInt(this.value[1]) - 1;
          this.day = parseInt(this.value[2]);
        }
      }
      this.render(this.year, this.month);
    },
    // 渲染日期
    render(y, m) {
      for (let g = 0; g < this.flag; g++) {
        if (g > 0) {
          if (m == 11) {
            m = 0;
            y = parseInt(this.year) + 1;
            this.month = 0;
            this.year = parseInt(this.year) + 1;
          } else {
            m = m + 1;
            this.month = parseInt(this.month) + 1;
          }
        }
        let firstDayOfMonth = new Date(y, m, 1).getDay(); //当月第一天
        let lastDateOfMonth = new Date(y, m + 1, 0).getDate(); //当月最后一天
        let lastDayOfLastMonth = new Date(y, m, 0).getDate(); //最后一月的最后一天
        this.year = y;
        //      let seletSplit = this.value;
        let seletSplit = this.$route.query.departure_date.split("-");
        let i,
          line = 0,
          temp = [],
          nextMonthPushDays = 1;
        for (i = 1; i <= lastDateOfMonth; i++) {
          let day = new Date(y, m, i).getDay(); //返回星期几（0～6）
          let k;
          // 第一行
          if (day == 0) {
            temp[line] = [];
          } else if (i == 1) {
            temp[line] = [];
            k = lastDayOfLastMonth - firstDayOfMonth + 1;
            for (let j = 0; j < firstDayOfMonth; j++) {
              if (g != 0) {
                k = "";
              }
              temp[line].push(
                Object.assign(
                  { day: k, disabled: true },
                  this.getLunarInfo(
                    this.computedPrevYear(),
                    this.computedPrevMonth(true),
                    k
                  ),
                  this.getEvents(
                    this.computedPrevYear(),
                    this.computedPrevMonth(true),
                    k
                  )
                )
              );

              k++;
            }
          }
          let chk = new Date();
          let chkY = chk.getFullYear();
          let chkM = chk.getMonth();
          // 匹配上次选中的日期
          if (
            parseInt(seletSplit[0]) == this.year &&
            parseInt(seletSplit[1]) - 1 == this.month &&
            parseInt(seletSplit[2]) == i
          ) {
            if (parseInt(seletSplit[2]) == this.day && i == this.day) {
              temp[line].push(
                Object.assign(
                  {
                    year: this.year,
                    month: this.month + 1,
                    day: i,
                    text: "今天",
                    selected: true,
                    today: true,
                  },
                  this.getLunarInfo(this.year, this.month + 1, i),
                  this.getEvents(this.year, this.month + 1, i)
                )
              );
            } else {
              temp[line].push(
                Object.assign(
                  {
                    year: this.year,
                    month: this.month + 1,
                    day: i,
                    selected: true,
                  },
                  this.getLunarInfo(this.year, this.month + 1, i),
                  this.getEvents(this.year, this.month + 1, i)
                )
              );
            }

            this.today = [line, temp[line].length - 1];
          }
          // 没有默认值的时候显示选中今天日期
          //        else if (
          //          chkY == this.year &&
          //          chkM == this.month &&
          //          i == this.day &&
          //          this.value == ""
          //        ) {
          //        	var arr = [this.year,this.month + 1,i]
          //          var todayJson = {};
          ////          if()
          //          temp[line].push(
          //            Object.assign(
          //              {
          //                year: this.year,
          //                month: this.month + 1,
          //                day: i,
          //                text: "今天",
          //                selected: true,
          //                today: true
          //              },
          //              this.getLunarInfo(this.year, this.month + 1, i),
          //              this.getEvents(this.year, this.month + 1, i)
          //            )
          //          );
          //          this.today = [line, temp[line].length - 1];
          //        }
          else {
            let currentMonth = Number(this.month) + 1;
            // 普通日期
            let options;
            if (chkY == this.year && chkM == this.month && i == this.day) {
              options = Object.assign(
                {
                  year: this.year,
                  month: currentMonth,
                  day: i,
                  text: "今天",
                  selected: false,
                  today: true,
                },
                this.getLunarInfo(this.year, this.month + 1, i),
                this.getEvents(this.year, this.month + 1, i)
              );
            } else {
              options = Object.assign(
                {
                  year: this.year,
                  month: currentMonth,
                  day: i,
                  selected: false,
                },
                this.getLunarInfo(this.year, this.month + 1, i),
                this.getEvents(this.year, this.month + 1, i)
              );
            }

            if (this.begin.length > 0) {
              let beginTime = Number(
                new Date(
                  parseInt(this.begin[0]),
                  parseInt(this.begin[1]) - 1,
                  parseInt(this.begin[2])
                )
              );
              if (beginTime > Number(new Date(this.year, this.month, i)))
                options.disabled = true;
            }
            if (this.end.length > 0) {
              let endTime = Number(
                new Date(
                  parseInt(this.end[0]),
                  parseInt(this.end[1]) - 1,
                  parseInt(this.end[2])
                )
              );
              if (endTime < Number(new Date(this.year, this.month, i)))
                options.disabled = true;
            }
            if (this.disabled.length > 0) {
              if (
                this.disabled.filter((v) => {
                  return (
                    this.year === v[0] && this.month === v[1] - 1 && i === v[2]
                  );
                }).length > 0
              ) {
                options.disabled = true;
              }
            }
            temp[line].push(options);
          }
          // 到周六换行
          if (day == 6 && i < lastDateOfMonth) {
            line++;
          }
        } //end for

        let currentMonth = Number(this.month) + 1;
        if (g == 0) {
          this.threeMonth = [];
        }
        this.threeMonth.push(
          Object.assign({
            date: this.year + "年" + currentMonth + "月",
            days: temp,
          })
        );
      }
    },
    computedPrevYear() {
      let value = this.year;
      if (this.month - 1 < 0) {
        value--;
      }
      return value;
    },
    computedPrevMonth(isString) {
      let value = this.month;
      if (this.month - 1 < 0) {
        value = 11;
      } else {
        value--;
      }
      // 用于显示目的（一般月份是从0开始的）
      if (isString) {
        return value + 1;
      }
      return value;
    },
    // 获取农历信息
    getLunarInfo(y, m, d) {
      let lunarInfo = calendar.solar2lunar(y, m, d);
      let lunarValue = lunarInfo.IDayCn;
      let isLunarFestival = false;
      let isGregorianFestival = false;
      let isVacation = false;
      let isFillUp = false;
      if (
        this.festival.lunar[lunarInfo.lMonth + "-" + lunarInfo.lDay] !=
        undefined
      ) {
        lunarValue =
          this.festival.lunar[lunarInfo.lMonth + "-" + lunarInfo.lDay];
        isLunarFestival = true;
        if (this.festival.vacationDate[m + "-" + d] != undefined) {
          isVacation = true;
          if (this.festival.vacationDate[m + "-" + d] == "班") {
            isFillUp = true;
          }
        }
      } else if (this.festival.gregorian[m + "-" + d] != undefined) {
        lunarValue = this.festival.gregorian[m + "-" + d];
        isGregorianFestival = true;
        if (this.festival.vacationDate[m + "-" + d] != undefined) {
          isVacation = true;
          if (this.festival.vacationDate[m + "-" + d] == "班") {
            isFillUp = true;
          }
        }
      }
      if (this.festival.vacationDate[m + "-" + d] != undefined) {
        lunarValue = this.festival.vacationDate[m + "-" + d];
        isVacation = true;
        if (this.festival.vacationDate[m + "-" + d] == "班") {
          isFillUp = true;
        }
      }

      return {
        lunar: lunarValue,
        isLunarFestival: isLunarFestival,
        isGregorianFestival: isGregorianFestival,
        isVacation: isVacation,
        isFillUp: isFillUp,
      };
    },
    // 获取自定义事件
    getEvents(y, m, d) {
      if (Object.keys(this.events).length == 0) return false;
      let eventName = this.events[y + "-" + m + "-" + d];

      let data = {};
      if (eventName != undefined) {
        data.eventName = eventName;
      }
      return data;
    },
    // 选中日期
    select(k0, k1, k2, e, init = false) {
      if (e != undefined) e.stopPropagation();
      // 取消上次选中
      if (this.today.length > 0) {
        for (let f = 0; f < this.flag; f++) {
          this.threeMonth[f].days.forEach((v) => {
            v.forEach((vv) => {
              vv.selected = false;
            });
          });
        }
      }

      // 设置当前选中天
      this.threeMonth[k0].days[k1][k2].selected = true;
      this.day = this.threeMonth[k0].days[k1][k2].day;
      this.today = [k1, k2];
      this.$emit("select", [
        this.zero
          ? this.zeroPad(this.threeMonth[k0].days[k1][k2].year)
          : this.threeMonth[k0].days[k1][k2].year,
        this.zero
          ? this.zeroPad(this.threeMonth[k0].days[k1][k2].month)
          : this.threeMonth[k0].days[k1][k2].month,
        this.zero
          ? this.zeroPad(this.threeMonth[k0].days[k1][k2].day)
          : this.threeMonth[k0].days[k1][k2].day,
      ]);
      this.getValue = [
        this.zero
          ? this.zeroPad(this.threeMonth[k0].days[k1][k2].year)
          : this.threeMonth[k0].days[k1][k2].year,
        this.zero
          ? this.zeroPad(this.threeMonth[k0].days[k1][k2].month)
          : this.threeMonth[k0].days[k1][k2].month,
        this.zero
          ? this.zeroPad(this.threeMonth[k0].days[k1][k2].day)
          : this.threeMonth[k0].days[k1][k2].day,
      ].toString();
      //   路由跳转、传递事件参数
      !init &&
        this.$router.replace({
          path: this.router,
          query: {
            departureDate_: this.getValue,
            departure_date: this.changeStyle(this.getValue),
            departure: this.$route.query.departure,
            destination: this.$route.query.destination,
            departure_city: this.$route.query.departure_city + "",
            arrive_city: this.$route.query.arrive_city + "",
            child_quantity: this.$route.query.child_quantity,
            baby_quantity: this.$route.query.baby_quantity,
            cabin: this.$route.query.cabin,
            token: localStorage.getItem("_token"),
          },
        });
    },
    reBack() {
      this.$router.replace({
        path: this.router,
        query: {
          departureDate_: this.$route.query.departure_date,
          departure_date: this.changeStyle(this.$route.query.departure_date),
          departure: this.$route.query.departure,
          destination: this.$route.query.destination,
          child_quantity: this.$route.query.child_quantity,
          baby_quantity: this.$route.query.baby_quantity,
          cabin: this.$route.query.cabin,
          token: localStorage.getItem("_token"),
          departure_city: this.$route.query.departure_city + "",
          arrive_city: this.$route.query.arrive_city + "",
        },
      });
    },
    changeStyle(par) {
      if (par) {
        par = par.replace(/,/g, "/");
      }
      let now = new Date();
      let select = new Date(par || now);
      return (
        select.getFullYear() +
        "-" +
        (select.getMonth() + 1 < 10
          ? "0" + (select.getMonth() + 1)
          : select.getMonth() + 1) +
        "-" +
        (select.getDate() < 10 ? "0" + select.getDate() : select.getDate())
      );
    },
    // 返回今天
    setToday() {
      let now = new Date();
      this.year = now.getFullYear();
      this.month = now.getMonth();
      this.day = now.getDate();
      this.render(this.year, this.month);
      // 遍历当前日找到选中
      this.days.forEach((v) => {
        let day = v.find((vv) => {
          return vv.day == this.day && !vv.disabled;
        });
        if (day != undefined) {
          day.selected = true;
        }
      });
    },
    // 日期补零
    zeroPad(n) {
      return String(n < 10 ? "0" + n : n);
    },
  },
};
</script>
